import { Components, Theme } from '@mui/material/styles';

export default function TextField({ palette, spacing, typography }: Theme): Components {
  return {
    MuiFormControl: {
      styleOverrides: {
        root: {
          '.MuiInputBase-colorWarning + .MuiFormHelperText-root': {
            color: palette.warning.dark,
          },
          '.MuiInputBase-colorSuccess + .MuiFormHelperText-root': {
            color: palette.success.dark,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: typography.caption.fontSize,
          fontWeight: 400,
          position: 'relative',
          transform: 'none',
          marginBottom: spacing(1),
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.MuiFormLabel-colorPrimary': {
            color: palette.text.primary,
            '&.Mui-focused': {
              color: palette.secondary.dark,
            },
            '&.Mui-disabled': {
              color: palette.text.disabled,
            },
          },
          '&.Mui-error': {
            color: palette.error.main,
            '&.Mui-focused': {
              color: palette.error.main,
            },
          },
          '&.MuiFormLabel-colorWarning': {
            color: palette.warning.dark,
          },
          '&.MuiFormLabel-colorSuccess': {
            color: palette.success.dark,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: '8.5px 14px',
          '&::placeholder': {
            opacity: 1,
            color: palette.action.disabled,
          },
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: false,
      },
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: palette.text.primary,
          },
          '&:hover, &.Mui-focused': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.secondary.dark,
            },
          },
          '&.Mui-disabled:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.text.disabled,
            },
          },
          '&.Mui-error': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.error.main,
            },
          },
          '&.MuiInputBase-colorWarning': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.warning.dark,
            },
          },
          '&.MuiInputBase-colorSuccess': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.success.dark,
            },
          },
        },
        input: {
          padding: '8.5px 14px',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: palette.text.primary,
          fontSize: typography.pxToRem(12),
          fontWeight: typography.fontWeightMedium,
          marginLeft: 0,
          marginRight: 0,
          textAlign: 'right',
        },
      },
    },
  };
}
